import React from 'react';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import "./VideoJSPlayer.css"

export default class VideoJSPlayer extends React.Component {

    // Initialize video.js player instance
    componentDidMount() {
        this.player = videojs(this.videoNode, this.props, () => {
            videojs.log('video player ready', this);
        });
    }

    // Destroy video.js player reference
    componentWillUnmount() {
        if (this.player) {
            this.player.dispose();
        }
    }

    // wrap player with data-vjs-player` attribute
    // so no additional wrapper are created in the DOM
    render() {
        return (
            <div data-vjs-player>
                <video ref={node => this.videoNode = node}
                       className="video-js"></video>
            </div>
        );
    }
}